import React from 'react';

import { Choice, Group, Toggle } from './OptionControls';

/**
 * The issues section's options: the lowest priority the open issues table
 * lists, and whether the page shows the overdue actions on those issues.
 */
const IssuesOptions = ({ options, readOnly, onChange }) => {
    const set = (changes) => onChange({ ...options, ...changes });

    return (
        <div className="tw-flex tw-flex-col tw-mt-3 tw-ps-4 tw-border-s-2 tw-border-charcoal-15">
            <Group title={$t('Issues')}>
                <Choice
                    id="mp-issues-rating"
                    label={$t('Open issues')}
                    value={options.min_rating}
                    choices={[
                        { value: 'high', label: $t('High only') },
                        { value: 'medium', label: $t('High and medium') },
                        { value: 'all', label: $t('All') },
                    ]}
                    disabled={readOnly}
                    onChange={(value) => set({ min_rating: value })}
                />
                <Toggle
                    label={$t('Overdue actions')}
                    hint={$t('Actions on the issues listed')}
                    checked={!!options.show_overdue_actions}
                    disabled={readOnly}
                    onChange={() => set({ show_overdue_actions: !options.show_overdue_actions })}
                />
            </Group>
        </div>
    );
};

export default IssuesOptions;
